﻿import type { FC } from 'react';

import type { MenuContentBaseProps } from '../components';
import { MenuContent } from '../components';
import { usePersonalBeautyStore } from '../contexts';
import { SocialContactType } from '../models';
import { getContactByType, replacePlaceholdersInUrl } from '../utils';
import { ComponentWrapper } from './ComponentWrapper';

export const MenuContentContainer: FC<MenuContentBaseProps> = (props) => {
  const { canDisplaySponsorInfo, pbsData } = usePersonalBeautyStore();

  if (!canDisplaySponsorInfo) {
    return null;
  }

  const { profile, productLists } = pbsData?.beautyStore ?? {};
  const { photoUrl, contacts, referralProgram } = profile ?? {};
  const { allowedContacts } = referralProgram ?? {};
  const { addThis: pplConfigurationAddThis, isPplEnabled } =
    pbsData?.application?.personalProductListConfiguration ?? {};
  const { sharedUrl: pplUrl } = pplConfigurationAddThis ?? {};

  const userEmail = getContactByType(allowedContacts, contacts, SocialContactType.Email);
  const userPhone = getContactByType(allowedContacts, contacts, SocialContactType.PhoneNumber);

  return (
    <ComponentWrapper>
      <MenuContent
        {...props}
        photoUrl={photoUrl}
        referralProgram={referralProgram}
        userEmail={userEmail}
        userPhone={userPhone}
        personalProductListConfiguration={{
          isEnabled: !!isPplEnabled,
          sharedUrl: replacePlaceholdersInUrl(pplUrl ?? '', {
            ...(productLists && productLists.length >= 1 ? { personallist: productLists[0]?.productListId } : {}),
          }),
        }}
      />
    </ComponentWrapper>
  );
};
